function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M66.0005 61.1129C66.0757 65.3711 70.7123 63.8226 73.098 63.2506C82.7954 60.9229 91.4642 59.1411 100.047 53.7497C115.974 43.7462 128.043 28.5477 135.851 11.7287C136.89 9.49107 141.076 2.39811 137.721 0.28661C135.509 -1.10604 134.168 2.94939 133.341 4.45464C129.136 12.1169 123.505 18.9 117.844 25.5579C105.273 40.3402 90.1626 49.7222 72.0831 56.5719C69.8658 57.4124 65.9455 58.0177 66.0005 61.1129Z",
  fill: "#113A69"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.54782 27.0168C4.98768 30.7483 6.1692 34.5726 7.42955 38.3619C8.36235 41.1665 9.01849 44.4272 11.3049 46.6183C13.6059 48.8234 15.6895 47.0388 15.4568 44.755C15.3236 43.4422 13.7725 41.5817 13.3435 40.2512C12.88 38.8103 12.5388 37.3284 12.1409 35.8691C10.978 31.6024 9.78222 26.9896 7.03844 23.3111C6.14228 22.1099 4.76969 20.2936 2.84397 20.2168C-1.27217 20.0518 2.88023 25.2861 3.54782 27.0168Z",
  fill: "#113A69"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.1039 39.9381C51.9002 43.8478 49.0645 48.0158 46.1183 52.0965C43.9377 55.1169 42.0546 58.8629 37.9801 60.3697C33.8796 61.8861 31.1922 58.4983 32.1658 55.7503C32.7246 54.1704 35.5902 52.6773 36.6041 51.2371C37.7004 49.6767 38.6217 47.9978 39.6231 46.3783C42.5504 41.6432 45.6217 36.4903 50.7958 33.3613C52.4857 32.3396 55.0676 30.8044 58.0196 31.7621C64.3297 33.8081 56.5895 38.1246 55.1039 39.9381Z",
  fill: "#113A69"
});

function SvgIllustration1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 66,
    viewBox: "0 0 139 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration1);
export default __webpack_public_path__ + "static/media/illustration1.c461229b7c8515f5a51af335c29ddb76.svg";
export { ForwardRef as ReactComponent };